<!--
 * @Author: ken yang
 * @Date: 2022-09-02 16:54:48
 * @LastEditTime: 2025-04-27 13:59:09
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/App.vue
-->
<template>
  <el-scrollbar
    ref="scrollbar"
    wrap-class=" column"
    :height="height"
    :class="[bodyClass, configStore.tradeStyle,'min-W','flow-auto','position-r', 'app-scrollbar']"
    :always="true"
    :noresize="true"
  >
    <FlexWidget :always="isSmallScreen" class="small-box" :class="isSmallScreen ? 'W' : ''">
      <el-config-provider :locale="locale">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <Component :is="Component" class="app-router-view" />
          </keep-alive>
        </router-view>
      </el-config-provider>
    </FlexWidget>
  </el-scrollbar>
</template>

<script setup>
import { Column } from '@/layout/index.js'
import { themeColors } from '@/config/themeColors.js'
import { useAppColorMode } from '@/hook/useAppColorMode.js'
import { getBusinessPath, resolveRedirectTarget } from '@/utils/localeRoute.js'
import { useZendeskLauncher } from '@/components/common/zendeskChatServiceLauncher/index.js'

const route = useRoute()
const userStore = useUserStore()
const quotesStore = useQuotesStore()
const configStore = useConfigStore()
const mapStore = useMapStore()
const mailStore = useMailStore()

useAppColorMode()
globalThis.$route = route

const tradeStore = useTradeStore()

const scrollbar = $ref(null)
let locale = $ref()
let height = $ref(window.innerHeight)
let width = $ref(window.innerWidth)

let bodyClass = $ref()
const isSmallScreen = $ref(false)
const setBodyClass = () => {
  if (window.innerWidth > 1200) {
    bodyClass = 'min-W'
    // isSmallScreen = false
  } else {
    bodyClass = ''
    // isSmallScreen = true
  }
}

const FlexWidget = $computed(() => isSmallScreen ? Column : Column)
const businessPath = $computed(() => getBusinessPath(route.path))
// const FlexWidget = $computed(() => isSmallScreen ? ElScrollbar : Column)

const setLocale = async () => {
  const langMap = {
    [LANGCN]: import('element-plus/dist/locale/zh-cn.mjs'),
    [LANGEN]: import('element-plus/dist/locale/en.mjs'),
    [LANGTW]: import('element-plus/dist/locale/zh-tw.mjs'),
    [LANGJA]: import('element-plus/dist/locale/ja.mjs'),
    [LANGKO]: import('element-plus/dist/locale/en.mjs'),
  }
  locale = (await langMap[configStore.locale]).default
}

const jumpPaths = ['/setNewPassword', '/login', '/loginAuth', '/user/register']

// 登录以后自动跳转到home
const autoJump = () => {
  if (jumpPaths.includes(businessPath) && userStore.token) {
    const redirectUrl = route.query?.redirect
    if (redirectUrl) {
      router.push(resolveRedirectTarget(redirectUrl))
    } else {
      router.push('/home')
    }
  }
}

useWinMesSetSize()

const applyThemeColorVariables = () => {
  const rootElement = document.documentElement
  Object.entries(themeColors).forEach(([key, values]) => {
    const currentTheme = values[configStore.theme] ?? values.light
    rootElement.style.setProperty(`--${key}`, currentTheme)
  })
}
// setTimeout(() => {
//   throw new Error('glitchtip test')
// }, 1000)

eventBus.on('onResize', e => {
  height = window.innerHeight
  width = window.innerWidth
  setBodyClass()
  scrollbar?.update()
})

watch(
  () => configStore.theme,
  () => {
    applyThemeColorVariables()
  },
  {
    immediate: true
  }
)

useZendeskLauncher()

watch(
  () => configStore.locale,
  (path) => {
    setLocale()
    mailStore.getList()
    mailStore.getUnreadCount()
  }
)

watch(
  () => configStore.locale,
  (newValue, oldValue) => {
    const htmlDom = document.querySelector('html')
    htmlDom?.classList.add(`app-language-${newValue}`)
    htmlDom?.classList.remove(`app-language-${oldValue}`)
  }
)

watch(() => route.path, (path, previousPath) => {
  const isBusinessPathChanged = !previousPath || getBusinessPath(path) !== getBusinessPath(previousPath)

  if (isBusinessPathChanged) {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    scrollbar?.setScrollTop(0)
  }

  if (businessPath == '/bft') {
    document.title = $t('bft.pageTitle')
  } else if (businessPath == '/ru') {
    document.title = $t('user.registerUpLandTitle')
  } else {
    document.title = 'BiFinance'
  }
  autoJump()
}, {
  immediate: true
})

watch(
  () => userStore.token,
  async () => {
    if (userStore.token) {
      userStore.logined()
    } else {
      mapStore.getAreaList()
      quotesStore.getTickers()
    }

    autoJump()
  }, {
    immediate: true
  }
)

eventBus.on('onAppSetScrollTop', () => scrollbar.setScrollTop(0))
eventBus.on('onAppSetScroll', (v) => scrollbar.setScrollTop(v))

// BiFinance
onBeforeMount(async () => {
  // localStorage.phoneAreaCode = localStorage.phoneAreaCode ?? '+86'
  setLocale()
  setBodyClass()
  if (!['production'].includes(envMode)) {
    console.log('当前环境', import.meta.env)
  }
})

// -----------将语言包导出成excel---------------
// import android from '@/language/zh/android.js'
// import downloadExcelLang from '@/utils/globalFunc/downloadExcelLang.js'
// downloadExcelLang(android)

onMounted(() => {
  width = window.innerWidth
})

</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@use '@/sass/index.scss' as *;
html,
body,
#app {
  margin: 0;
  padding: 0;
}
iframe {
  border: 0px;
}
.group-2JyOhh7Z- {
  background-color: transparent !important;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-default);
}
</style>
